<template>
	<div>
		<div>
			<!-- 头图 -->
			<img class="top-img" :src="data.topImg" alt="" />
			<!-- 信息采集模块 -->
			<div v-if="data.switchInfoCollect" class="info-collect" :style="{ marginTop: (data.infoMargin ) / 16 + 'rem' }">
				<p class="info-collect-title">{{ data.infoTitle }}</p>
				<div class="info-collect-btn">
					<span v-for="(btnItem, btnIndex) in data.infoBtnList" :key="btnIndex"
						:style="btnIndex === activeSelectedbtn ? {
							border: `${data.switchBtnBorder ? '0.0625rem' : 0} solid ${data.infoBtnBorder}`,
							backgroundColor: data.infoBtnBackGround,
							color: data.infoBtnColor
						} : {}" @click="handleSelectedInfo(btnIndex)"
					>{{ btnItem.name }}</span>
				</div>
			</div>
			<!-- 手机号输入框 -->
			<div class="phone-area">
				<input
					type="tel"
					maxlength="11"
					autocomplete="off"
					ref="phoneInput"
					v-model="phoneNumber"
					:placeholder="data.phoneTips"
					:style="{ border: `0.0625rem solid ${data.phoneBorder}` }"
					class="text-input DINPro-Medium"
					@focus="showClearIcon"
					@blur="hideClearIcon"
					@input="phoneNumber=phoneNumber.replace(/[^\d]/g,'')"
					@keydown.delete="onKeydown()"
				/>
				<div class="input-icon" @click="clearPhoneNumber"></div>
				<!-- <div v-if="isShowClearIcon" class="input-icon" @click="clearPhoneNumber"></div> -->
			</div>
			<!-- 协议勾选框 -->
			<div class="protocol-area" @click="changeProtocolSelectStatus">
				<div class="protocol-area-click">
					<img class="protocol-area-img" :src="protocolImg" alt="" />
				</div>
				<p
					class="protocol-area-tips"
					:style="{
						color: data.tipsColor
					}"
				>
					{{ data.protocolTips
					}}<span
						@click.stop="handlePreviewProtocol(item)"
						:style="{ color: data.protocolColor }"
						v-for="(item, index) in data.protocolList"
						:key="index"
						>{{ item.title }}</span
					>
				</p>
			</div>
			<!-- 按钮 -->
			<div class="register-btn-box" ref="mainBtnRef">
				<div
					class="register-btn"
					:style="{
						color: data.contentColor,
						background: data.btnColor,
						boxShadow: data.btnShadow
					}"
					v-debounce
					@click="goToRegister"
				>
					{{ data.btnContent }}
				</div>
				<p v-if="data.btnBubble" class="register-btn-bubble" :style="{
					color: data.btnBubbleColor,
					background: data.btnBubbleBack,
				}">{{ data.btnBubble }}</p>
			</div>
		</div>
		<!-- 页面底部固底按钮 fixed定位 灰度判断是否展示 -->
		<div v-if="showOtherBtn" class="fixed-bottom" :class="isIphoneX && 'fixed-bottom-iphoneX'">
			<div
				class="register-btn register-btn-bottom"
				:style="{
					color: data.contentColor,
					background: data.btnColor,
				}"
				v-debounce
				@click="goToRegister"
			>
				{{ data.btnContent }}
			</div>
		</div>
		<!-- 图形验证码弹窗 -->
		<div v-if="isShowImgCode" class="pop-box">
			<div class="msg-box">
				<div class="msg-box-title">输入图形验证码</div>
				<div class="close" @click="closeImgVerify"></div>
				<div class="form-item">
					<div class="form-item-code">
						<input
							v-model="userImgCode"
							class="code-input"
							type="text"
							placeholder="请输入图形验证码"
							autocomplete="off"
							@focus="focusCode"
						/>
					</div>
					<div class="btn-img-code-wrapper" style="border: none" @click="getImgCode">
						<img class="img-code" :src="imgCode" alt="图形验证码" border="0" />
					</div>
				</div>
				<div class="info">
					<div class="code-info">
						<span v-if="notRealCode">验证码错误</span>
					</div>
					<div class="img-info" @click="getImgCode">
						<span>看不清？换一张</span>
					</div>
				</div>
				<div class="code-submit" @click="queryMessageCode">确定</div>
			</div>
		</div>
		<!-- 底部短信验证码弹窗 -->
		<!-- <div class="popup-abs" @touchmove.prevent> -->
		<div v-if="isShowPopup" class="popup-abs" @touchmove.prevent>
			<div v-if="notgetCode" class="popup-nocode">
				<img
					src="https://datahub.haohuan.com/gfs/2022-11/d45f53794a127e73472eb1e1f3950a44-8.png"
					class="popup-nocode-backimg"
					@click="handleBackVerifyCode"
				/>
				<p class="popup-nocode-title">收不到验证码?</p>
				<div class="popup-nocode-content">
					<p>1.请检查手机号是否正确；</p>
					<p>
						2.请检查是否有屏蔽短信通知，并打开“短信”应用，查看已发送的验证码；
					</p>
					<p>3.如上述方法未能解决，请拨打好分期客服热线400-085-6608</p>
				</div>
			</div>
			<!-- <div v-else class="popup-bottom" :class="{ 'popup-bottom-focus': isFocus }" > -->
			<div v-else class="popup-bottom" :class="{ 'popup-bottom-focus': isFocus, 'popup-bottom-ios': isIOS }" >
				<img
					class="popup-bottom-close"
					src="https://datahub.haohuan.com/gfs/2021-12/a8a6ec5f4f7e5d91e62c56fe74eb41bc.png"
					@mousedown="handleCloseClick"
				/>
				<p class="popup-bottom-title">注册验证</p>
				<p class="popup-bottom-tips">验证码已发送{{ slicePhoneNumber }}</p>

				<!-- 引用短信验证码组件 -->
				<msg-code id="msgCodeArea" @handleRegister="handleRegister" @handlePageFocus="handlePageFocus" @handlePageBlur="handlePageBlur" :isCorrectCode="isCorrectCode"></msg-code>

				<div class="verify-code">
					<span @mousedown="handleNotGetCode" class="not-get-code">收不到验证码？</span>
					<span @mousedown="reGetCode" v-debounce class="right-tips" :class="showReGet && 'right-tips-red'">{{ rightTips }}</span>
				</div>
			</div>
		</div>
		<!-- 注册成功、错误提示弹窗 -->
		<div v-if="isShowTipsPopup" class="dialog-success">
			<div class="dialog-bg" />
			<div class="dialog-box">
				<h3 class="title">提示</h3>
				<div class="text">{{ dialogText }}</div>
				<div v-if="registerSuccess" class="dialog-buttons" @click="handleDownLoad">立即下载</div>
				<div v-else class="dialog-buttons" @click="handleUserClick">我知道了</div>
			</div>
		</div>
		<!-- 下载组件 -->
		<down-load :downFun="downFun"></down-load>
	</div>
</template>

<script>
import throttle from "lodash/throttle";
import { post } from "../common/http";
import createMessage from "./Toast/index.js";
import msgCode from "./msgcode.vue";
import downLoad from "./download.vue";
import { isIphoneX, getUrlParam, sensorsBuriedPoint, isTestEnv } from '../common/util';

let utmGroup;
const params = new URLSearchParams(window.location.search);
const queryCode = params.get("code");
const wishPhase = params.get("wishPhase");
const wishCode = params.get("wishCode");
const newXijing = params.get("newXijing");
const isXijing = params.get("isXijing");
const [ , codeB ] = queryCode.split('@');
if (codeB) {
	utmGroup = localStorage.getItem("useGroup");
} else {
	utmGroup = "未分组"
}

export default {
	data() {
		return {
			phoneNumber: "",
			protocolImg: "",
			isAgreeProtocol: true,
			isShowClearIcon: false,
			isShowImgCode: false,
			needVerifyCode: true, // 是否需要短信验证码
			verifyCode: "", // 短信验证码
			dialogText: '', // 弹窗内容
			userImgCode: "",
			notRealCode: false,
			imgCode: "",
			isShowPopup: false,
			screenHeight: document.documentElement.clientHeight,
			messageAgent: params.get("agent") || '',
			secretMobile: params.get("enc_pn") || '',
			simpleInput: "",
			rightTips: "",
			time_count: 0,
			registerSuccess: false,
			downFun: 0,
			isShowTipsPopup: false,
			isCorrectCode: 0,
			isFocus: false,
			isIOS: false,
			notgetCode: false,
			hfqOrigin: '', // 渠道来源
			verifyCodePeriod: 0, // 验证码发送间隔
			geeTestInfo: {
				lotNumber: '',
				captchaOutput: '',
				passToken: '',
				genTime: ''
			},
			JyABGroup: '对照组',
			showOtherBtn: false, // 页面滚动后底部按钮
			mainBtnOffsetTop: 0,
			isIphoneX: isIphoneX(),
			currentRandom: -1,
			isDirectShowPhone: false, // 是否反显手机号
			activeSelectedbtn: -1, // 当前选择的信息采集框
		};
	},
	components: {
		msgCode,
		downLoad
	},
	props: {
		data: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	computed: {
		slicePhoneNumber() {
			return this.phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
		},
		showCodePopup() {
			return this.isShowTipsPopup || this.isShowImgCode;
		},
		showReGet() {
			return this.rightTips === '重新获取'
		},
		preLoadphone() { // 是否需要预加载手机号
			return !!this.secretMobile && !!this.messageAgent;
		},
		requestMobile() { // 手机号反显时传密文否则传明文
			return this.isDirectShowPhone ? this.secretMobile : this.phoneNumber;
		},
		infoCollectParams() { // 信息采集埋点内容
			try {
				// 不展示信息采集模块
				if (!this.data.switchInfoCollect) {
					return {
						InforTitle: '未配置内容',
						InforSelectContent: '未配置内容',
						InforSelectResult: '未配置内容'
					}
				}
				const selectBtn = this.data.infoBtnList[this.activeSelectedbtn] || {};
				return {
					InforTitle: this.data.infoTitle,
					InforSelectContent: this.data.infoBtnList.map(item => item.name).join(','),
					InforSelectResult: selectBtn.name || '未选择内容'
				}
			} catch (error) {
				console.log('信息采集埋点', error);
				return {
					InforTitle: '未配置内容',
					InforSelectContent: '未配置内容',
					InforSelectResult: '未配置内容'
				}
			}
		},
	},
	watch: {
		showCodePopup(newVal) {
			let curElement = document.querySelector("body");
			if (newVal) {
				window.scroll(0, 0);
				curElement.style.overflow = "hidden";
			} else {
				curElement.style.overflow = "";
			}
		},
		phoneNumber(newVal) {
			// 手机号反显时不进行校验
			if (this.isDirectShowPhone) return;
			if (newVal.length === 11) {
				// 判断手机号输入是否正确
				const telReg = /^1[3456789]\d{9}$/;
				if (!telReg.test(this.phoneNumber)) {
					createMessage({
						text: "请输入正确手机号",
						timeout: 2000
					});
					return;
				}
			}
		}
	},
	mounted() {
		const startTime = performance.now();
		this.handleBtnGrayInfo();
		this.changeProtocolSelectStatus();
		// 判断是否需要返显手机号
		this.preLoadphone && this.getDecrptedData();
		// 埋点
		sensorsBuriedPoint("RegisterPageView", this.formatSensorData({ PreLoadphone: this.preLoadphone, timeSpan: performance.now() - startTime}), false);
		if (/iPhone/i.test(navigator.userAgent)) {
			this.isIOS = true;
		}
		try {
			this.hfqOrigin = (getUrlParam("hfqorigin") || "").substring(0, 8);
		} catch (error) {
			console.log('获取地址栏参数失败', error);
			this.hfqOrigin = "";
		}
		// 安卓键盘弹起和收起事件
		const innerHeight = window.innerHeight;
		window.addEventListener('resize', () => {
			const newInnerHeight = window.innerHeight;
			if (innerHeight > newInnerHeight) {
				// 键盘弹出
				this.isFocus = true;
			} else {
				this.isFocus = false;
			}
		});

	},
	methods: {
		handleSelectedInfo(index) {
			this.activeSelectedbtn = index;
			sensorsBuriedPoint("RegiInforSelectResult", this.formatSensorData(this.infoCollectParams), false);
		},
		handleBtnGrayInfo() {
			let rawGrayInfo = [];
			try {
				// 缓存中获取灰度信息
				rawGrayInfo = JSON.parse(sessionStorage.getItem("grayInfo"));
				this.currentRandom = localStorage.getItem("btnEffectRandom") || Math.random();
			} catch (error) {
				rawGrayInfo = [];
				this.currentRandom = Math.random();
			}
			if (!rawGrayInfo.length) return; // 没有配置灰度不做处理
			console.log('获客投放页面随机数', this.currentRandom);
			localStorage.setItem("btnEffectRandom", this.currentRandom);
			if (rawGrayInfo[1] && this.currentRandom >= rawGrayInfo[1]) {
				const img = new Image;
				img.src = this.data.topImg;
				img.onload = () => {
					this.mainBtnOffsetTop = this.$refs.mainBtnRef.offsetTop + 90 || 400;
				}
				// 获取页面按钮离顶部的距离
				window.addEventListener("scroll", this.scrollShowContent, true);
			}
		},
		scrollShowContent: throttle(function () {
			const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			console.log('页面滚动距离', scrollTop);
			this.showOtherBtn = scrollTop > this.mainBtnOffsetTop;
			let curElement = document.querySelector('body');
			curElement.style.paddingBottom = this.showOtherBtn ? '5.125rem' : 0;
		}, 200),

		getDecrptedData() {
			post("/api/v1/landingPage/getDecrptedData", {
				agent: this.messageAgent,
				encPhone: this.secretMobile
			}).then(res => {
				const { code, data} = res || {};
				// 入参不正确时，接口有可能报错或者返回空对象
				if (code === 0 && JSON.stringify(data) !== '{}') {
					// 解密接口返回的是隐去中间4位的手机号
					this.phoneNumber = data;
					this.isDirectShowPhone = true; // 手机号反显
				}
			})
		},
		onKeydown() {
			// 用户点击删除按钮，如果是反显手机号，直接清空反显内容
			if (this.isDirectShowPhone) {
				this.phoneNumber = '';
				this.isDirectShowPhone = false;
			}
			this.userImgCode = '';
		},
		// 埋点公共属性
		formatSensorData(data) {
			let extraData = {};
			if (isXijing || newXijing) {
				extraData = { IsNewXiJing: newXijing ? 1 : 0 }
			}
      return {
				SourceName: getUrlParam("channel_name") || "",
        utm_source: getUrlParam("utm_source") || "",
        utm_content: utmGroup,
				PageName: localStorage && localStorage.getItem("pageName") || "",
				ReturnPolicy: getUrlParam("deep_type") || "",
				hfqOrigin: getUrlParam("hfqorigin") || "",
				btnEffectRandom: this.currentRandom,
				...extraData, 
				...data
			}
    },
		handleRegister(code) {
			code && (this.verifyCode = code);
			console.log("短信验证码code", code, this.verifyCode);
			sessionStorage.setItem("noPassword", "true")
			sensorsBuriedPoint("RegiSubmitCode", this.formatSensorData(), false);
			const data = JSON.stringify({
				data: {
					mobile: this.requestMobile,
					phrase: this.userImgCode,
					code: this.verifyCode,
					td_key: "default",
					pre_orderid: getUrlParam("pre_orderid") || undefined,
					composite: getUrlParam("composite") || undefined,
					utm_source: getUrlParam("utm_source") || undefined,
					adid: getUrlParam("adid") || undefined,
					creativeid: getUrlParam("creativeid") || undefined,
					creativetype: getUrlParam("creativetype") || undefined,
					clickid: getUrlParam("clickid") || undefined,
					deepType: getUrlParam("deep_type") || undefined,
					pageId: `${getUrlParam("utm_medium")}_${sessionStorage.getItem("tplId")}` || "",
					agent: this.messageAgent,
				}
			});
			post("/api/v2/web/register", data).then(res => {
				console.log("注册接口", res);
				const { code, data } = res;
				if (code === 0) {
					if (data.need_captcha === 1) {
						this.userImgCode = "";
						// 弹窗图形验证码
						this.getImgCode();
						this.isShowImgCode = true;
						sensorsBuriedPoint("ImageCodeView", this.formatSensorData(), false);
						this.needVerifyCode = false; // 不需要短信验证码
						// 短信验证码弹窗关闭
						this.isShowPopup = false;
					} else {
						// 注册成功，显示下载提示框
						console.log("下载提示框");
						this.registerSuccess = true;
						// 短信验证码弹窗关闭
						this.isShowPopup = false;
						// 图形验证码弹窗关闭
						this.isShowImgCode = false;
						this.dialogText = "恭喜您注册成功！";
						this.isShowTipsPopup = true;
						sensorsBuriedPoint("RegiDownloadPopView", this.formatSensorData(), false);
						// 使用userkey作为登录ID
						sensors.login(data.systemUniqueId);
						// 向后传递userkey
						sessionStorage.setItem("userkey", data.systemUniqueId);
						// 用户属性 注册来源渠道
						sensors.setProfile({ UtmSourceUser: getUrlParam("channel_name") });
						// 签约许愿会邀请用户注册，在注册之后需要进行邀请者和被邀请者的绑定
						if(wishPhase && wishCode){
							const wishData = {
								mobile: this.requestMobile,
								code: wishCode,
								systemUniqueId:data.systemUniqueId,
								activityId: Number(wishPhase)
							}
							post("/api/v1/wish/share/invitation", wishData)
						}
					}
				} else if (code === 1020) {
					this.isShowTipsPopup = true;
					this.dialogText = "图形验证码错误，请重试！";
					this.userImgCode = "";
					this.getImgCode();
					this.isShowImgCode = true;
					this.isShowPopup = false;
					sensorsBuriedPoint("ImageCodeView", this.formatSensorData(), false);
					this.needVerifyCode = false; // 不需要短信验证码
				} else if (code === 1306 || code === 1307) {
					createMessage({
						text: "验证码有误，请重新输入！",
						timeout: 2000
					});
					// 关闭图形验证码弹窗
					this.isShowImgCode = false;
					// 展示短信验证码弹窗
					this.isShowPopup = true;
					// 告诉子组件 输入的短信验证码清空 重新输入
					this.isCorrectCode++;
				} else {
					createMessage({
						text: `${res.desc}`,
						timeout: 2000
					});
					// 短信验证码弹窗关闭
					this.isShowPopup = false;
				}
				// 埋点
				sensorsBuriedPoint("RegiResult", this.formatSensorData({
					IsSucess: code === 0,
					FailReason: res.desc || '',
					IsNew: data && !data.action,
					JyABGroup: this.JyABGroup
				}), false);
			});
		},
		// 短验弹窗组件 input框 聚焦事件
		handlePageFocus(index) {
			console.log('短验弹窗组件 input框 聚焦事件', index);
			// IOS第一次聚焦
			// if (this.isIOS && this.firstFocus) return
			// if (e) {
				// this.isFocus = true;
			// }
			// this.isFocus = !!e;
			// setTimeout(() => {
      //   if (!index && this.isIOS) {
      //     window.scrollTo(0, document.body.clientHeight);
      //   }
      // }, 100)
			this.isFocus = true;
		},
		handlePageBlur(index) {
			// if (!index && this.isIOS) {
			// 	window.scrollTo(0, 0);
			// }
			this.isFocus = false;
			// this.firstFocus = false;
		},
		changeProtocolSelectStatus() {
			this.isAgreeProtocol = !this.isAgreeProtocol;
			this.protocolImg = this.isAgreeProtocol ? this.data.selectedImg : this.data.noSelectImg;
		},
		handlePreviewProtocol(item) {
			location.href = item.link;
		},
		goToRegister() {
			// 没有输入手机号，输入框聚焦
			if (!this.phoneNumber) {
				this.$refs.phoneInput.focus();
				return;
			}
			// 手机号校验时机：没有反显；有反显但是修改过
			if (!this.isDirectShowPhone){
				// 判断手机号输入是否正确
				const telReg = /^1[3456789]\d{9}$/;
				if (!telReg.test(this.phoneNumber)) {
					createMessage({
						text: "请输入正确手机号",
						timeout: 2000
					});
					return;
				}
			}
			// 判断是否同意协议
			if (!this.isAgreeProtocol) {
				createMessage({
					text: "请阅读并勾选协议",
					timeout: 2000
				});
				return;
			}
			sensorsBuriedPoint("RegiGetCodeClick", this.formatSensorData({
				BubbleContent: this.data.btnBubble || '未配置内容',
				...this.infoCollectParams
			}), false);
			// 调用验证码接口
			this.handleMessage();
		},
		// 手机号输入框聚焦
		showClearIcon() {
			this.isShowClearIcon = true;
			sensorsBuriedPoint("RegiInputPhone", this.formatSensorData(), false);
		},
		hideClearIcon() {
			this.isShowClearIcon = false;
		},
		clearPhoneNumber() {
			console.log("清除手机号");
			this.phoneNumber = "";
			this.userImgCode = '';
			this.isDirectShowPhone = false;
		},
		async getValidateSendPeriod() {
			const sendPeriodUrl = this.isDirectShowPhone ? '/api/v1/landingPage/getValidateSendPeriod' : '/api/v1/sms/getValidateSendPeriod';
			await post(sendPeriodUrl, {
				type: "html",
				mobile: this.requestMobile,
				agent: this.messageAgent,
			}).then(res => {
				const { code, data = {} } = res;
				if (code === 0) {
					this.verifyCodePeriod = data.period || 0;
				}
			})
		},
		// 获取短信验证码
		async handleMessage(flag) {
			// 清空极验验证信息
			flag !== 2 && (this.geeTestInfo = {});
			// 获取验证码发送间隔
			await this.getValidateSendPeriod();
			if (this.verifyCodePeriod > 0) {
				// 展示验证码弹窗
				this.isShowImgCode = false;
				this.isShowPopup = true;
				sensorsBuriedPoint("CodePopView", this.formatSensorData(), false);
				this.time_count = this.verifyCodePeriod;
				this.handleTime();
				return;
			}
			const data = {
				type: "html",
				mobile: this.requestMobile,
				phrase: this.userImgCode,
				hfqOrigin: this.hfqOrigin,
				composite: undefined,
				supportGeeTest: true,
				geeTestInfo: this.geeTestInfo,
				agent: this.messageAgent,
			};
			const sendVerifyCodeUrl = this.isDirectShowPhone ? '/api/v1/landingPage/sendVerifyCode' : '/api/v2/web/send-verify-code';
			post(sendVerifyCodeUrl, data)
				.then(res => {
					console.log("获取短信验证码", res);
					const { code, data } = res;
					if (code === 0) {
						if (data.need_captcha === 1) {
							if (data.verifyCaptchaType == 1) {
								this.JyABGroup = '实验组';
								// 关闭短信验证码弹窗
								this.isShowPopup = false;
								// 极验验证码
								initGeetest4({
									captchaId: isTestEnv() ? 'ef04bb1ddd37ee07716222de16664440' : '58e3d77957533397222edfb9afa2f4b4',
									product: 'bind',
									nextWidth: '16.25rem',
									hideSuccess: true,
									hideBar: ['close', 'refresh']
								}, (captchaObj) => {
									captchaObj.onReady(() => {
										// 当product为bind类型时，可以调用该接口展示验证
										captchaObj.showCaptcha();
										this.$nextTick(() => {
											// const geeFooter = document.getElementsByClassName('geetest_footer');
											// geeFooter[0].remove();

											// geetest_feedback
											const geeFeedBack = document.getElementsByClassName('geetest_feedback');
											geeFeedBack[0] && geeFeedBack[0].remove();

											// geetest_footer_right
											const geeFooterRight = document.getElementsByClassName('geetest_footer_right');
											geeFooterRight[0] && geeFooterRight[0].remove();
										})
									})
									// 监听验证成功事件
									captchaObj.onSuccess(() => {
										const result = captchaObj.getValidate();
										console.log('验证通过', result);
										captchaObj.reset(); // 调用该接口进行重置
										// 调用后端方法进行二次验证
										const { captcha_output: captchaOutput, gen_time: genTime, lot_number: lotNumber, pass_token: passToken, isOffline = false } = result;
										isOffline && sensorsBuriedPoint("JyWebError", {}, false);
										this.geeTestInfo = { lotNumber, captchaOutput, passToken, genTime };
										this.handleMessage(2);
									});
								});
								sensorsBuriedPoint("JYCodeView", this.formatSensorData(), false);
								return;
							}
							this.userImgCode = "";
							this.notRealCode = false;
							// 弹窗图形验证码
							this.getImgCode();
							this.isShowImgCode = true;
							sensorsBuriedPoint("ImageCodeView", this.formatSensorData(), false);
							this.needVerifyCode = true; // 需要短信验证码
							// 页面滚动到顶部
							window.scrollTo(0, 0);
							// 关闭短信验证码弹窗
							this.isShowPopup = false;
						} else {
							this.isShowImgCode = false;
							this.isShowPopup = true;
							sensorsBuriedPoint("CodePopView", this.formatSensorData(), false);
							this.time_count = data.expire_time;
							this.handleTime();
						}
					} else if (code === 13041) {
						console.log("验证码发送过于频繁，请1分钟后再试");
						createMessage({
							text: "验证码发送过于频繁，请1分钟后再试",
							timeout: 2000
						});
						if (flag === 1) {
							// 关闭图形验证码弹窗
							this.userImgCode = "";
							this.isShowImgCode = false;
						}
					} else if (code === 1020) {
						console.log("图形验证码错误，请重试！");
						createMessage({
							text: "图形验证码错误，请重试！",
							timeout: 2000
						});
						this.userImgCode = "";
						this.getImgCode();
					} else if (code === 1021) {
						this.geeTestInfo = {};
						createMessage({
							text: "验证失败，建议操作重试",
							timeout: 2000
						});
					} else {
						console.log("获取验证码失败，请重试");
						createMessage({
							text: "获取验证码失败，请重试",
							timeout: 2000
						});
					}
					// 埋点
					sensorsBuriedPoint("SendCode", this.formatSensorData({
						IsSucess: code === 0,
						FailReason: res.desc || '',
						JyABGroup: this.JyABGroup
					}), false);
				})
				.catch(err => {
					console.log("我到catch了", err);
					// this.notRealCode = true;
				});
		},
		handleTime() {
			if (!this.timer) {
				this.timer = setInterval(() => {
					if (this.time_count) {
						this.rightTips = this.time_count + "秒后重发";
						this.time_count--;
					} else {
						clearInterval(this.timer);
						this.rightTips = "重新获取";
						this.timer = null;
						this.time_count = 0;
					}
				}, 1000);
			}
		},
		// 获取图形验证码
		getImgCode() {
			const getCaptchaImageUrl = this.isDirectShowPhone ? '/api/v1/landingPage/getCaptchaImage' : '/api/v1/captcha/get-captcha-image';
			post(getCaptchaImageUrl).then(res => {
				console.log("获取图形验证码接口", res);
				if (res.code === 0) {
					this.imgCode = res.data.path;
				} else {
					createMessage({
						text: "获取图形验证码失败，请重试！",
						timeout: 2000
					});
				}
			});
		},
		// 图形验证码单击确定
		queryMessageCode() {
			if (!this.userImgCode.length) {
				createMessage({
					text: "请输入验证码",
					timeout: 2000
				});
				return
			}
			if (!/^\d\d{4}\d$/.test(this.userImgCode)) {
				createMessage({
					text: "验证码错误，请重新输入",
					timeout: 2000
				});
				// this.notRealCode = true;
				return;
			}
			// 如果需要短信验证码，调获取短信验证码接口，不需要则调注册接口
			this.needVerifyCode ? this.handleMessage(1) : this.handleRegister()
		},
		focusCode() {
			this.notRealCode = false;
		},
		handleCloseClick() {
			let curElement = document.querySelector("body");
			curElement.style.overflow = "";
			this.isShowPopup = false;
			this.rightTips = "";
		},
		closeImgVerify() {
			this.userImgCode = "";
			this.isShowImgCode = false;
		},
		handleNotGetCode() {
			console.log('收不到验证码点击事件');
      this.notgetCode = true;
			this.isFocus = false;
    },
    handleBackVerifyCode() {
      this.notgetCode = false;
    },
		reGetCode() {
			if (!this.time_count) {
				// 重新获取验证码
				this.handleMessage();
			}
		},
		// 注册成功，下载APP
		handleDownLoad() {
			sensorsBuriedPoint("RegiDownloadClick", this.formatSensorData({
				BubbleContent: this.data.btnBubble || '未配置内容',
				...this.infoCollectParams
			}), false);
			this.downFun = +new Date();
			this.isShowTipsPopup = false;
			this.registerSuccess = false;
		},
		handleUserClick() {
			this.isShowTipsPopup = false;
		},
	}
};
</script>

<style lang="less" scoped>
.top-img {
	width: 100%;
}
.info-collect {
	margin: 0 20px 23px;
	&-title {
		height: 23px;
		font-size: 16px;
		font-family: PingFangSC, PingFang SC;
		font-weight: bold;
		color: #2E2E33;
		line-height: 23px;
		margin-bottom: 12px;
	}
	&-btn {
		display: flex;
		justify-content: space-between;
		span {
			width: 78px;
			height: 32px;
			line-height: 32px;
			background: rgba(118,121,166,0.07);
			border-radius: 16px;
			text-align: center;
			font-size: 13px;
			font-family: PingFangSC, PingFang SC;
			color: #919199;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			word-break: break-all;
		}
	}
}
.phone-area {
	position: relative;
	width: 335px;
	height: 50px;
	margin: 5px 20px 0;
}
.text-input {
	width: 335px;
	height: 50px;
	background: #ffffff;
	border-radius: 27px;
	outline: none;
	overflow: hidden;
	line-height: 21px;
	font-size: 15px;
	resize: none;
	word-break: break-all;
	box-sizing: border-box;
	padding-left: 25px;
	-webkit-appearance: none;
	font-family: DINPro-Regular, DINPro;
}
.input-icon {
	position: absolute;
	top: 19px;
	right: 22px;
	background: url("https://datahub.haohuan.com/gfs/2022-11/cf7d21324b4a893ccab57591fd209c9d-8.png");
	background-size: 100% 100%;
	width: 15px;
	height: 15px;
}
.protocol-area {
	display: flex;
	padding: 12px 12px 12px 0;
	&-click {
		padding: 0 7px 0 19px;
	}
	&-img {
		width: 16px;
		height: 16px;
	}
	&-tips {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		line-height: 20px;
	}
}
.register-btn-box {
	position: relative;
	padding: 0 20px 30px;
}
.register-btn {
	width: 335px;
	height: 50px;
	line-height: 50px;
	text-align: center;
	border-radius: 23px;
	font-size: 18px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
}
.register-btn-bubble {
	position: absolute;
	right: 20px;
	top: 2px;
	height: 18px;
	line-height: 18px;
	font-size: 11px;
	border-radius: 10px 10px 10px 0px;
	font-family: DINPro-Regular, DINPro;
	font-weight: 500;
	padding: 0 5px;
}
.register-btn-bottom {
	width: 351px;
}
.fixed-bottom {
	position: fixed;
	z-index: 100;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: #fff;
	height: 82px;
	background: #FFFFFF;
	border-top: 1px solid #EDEDF0;
	padding: 16px 12px;
}
.fixed-bottom-iphoneX {
	height: 100px;
}
.pop-box {
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	background: rgba(3, 3, 3, 0.5);
	min-height: 100vh;
	z-index: 99998;
	.msg-box {
		position: relative;
		max-width: 300px;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: block;
		z-index: 10000;
		background-color: #fff;
		border-radius: 8px;
		padding: 20px 0 14px;
		text-align: center;
		color: #666;
		.close {
			position: absolute;
			top: 10px;
			right: 10px;
			width: 24px;
			height: 24px;
			background: url("https://datahub.haohuan.com/gfs/2022-10/f4197af525d8ee7b04b474b6d4d7c32a-8.png");
			background-size: 100% 100%;
		}
		&-title {
			height: 25px;
			font-size: 17px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #333333;
			line-height: 25px;
		}
		.form-item {
			position: relative;
			margin: 16px 20px 10px;
			height: 45px;
			background: #fafafa;
			border-radius: 4px;
			border: 1px solid #ededed;
			overflow: hidden;
			// display: flex;
			// justify-content: space-between;
			// margin-top: 24px;
			// padding: 10px 10px 5px;
			// line-height: 40px;
			&-code {
				font-size: 14px;
				line-height: 45px;
				// border: 1px solid #c0c0c0;
				padding-left: 5px;
				// width: 55%;
				.code-input {
					// border: none;
					// outline: none;
					width: 100%;
					height: 42px;
					background: #fafafa;
					outline: none;
					overflow: hidden;
					line-height: 44px;
					font-size: 15px;
					resize: none;
					word-break: break-all;
					box-sizing: border-box;
					padding-left: 5px;
					-webkit-appearance: none;
					font-family: DINPro-Regular, DINPro;
					&::-webkit-input-placeholder {
						color: #c6cace;
						font-size: 14px;
					}
					&:-moz-placeholder {
						color: #c6cace;
						font-size: 14px;
					}
					&::-moz-placeholder {
						color: #c6cace;
						font-size: 14px;
					}
					&:-ms-input-placeholder {
						color: #c6cace;
						font-size: 14px;
					}
				}
			}
			.btn-img-code-wrapper {
				position: absolute;
				top: 0;
				right: 0;
				height: 43px;
				line-height: 43px;
				width: 42%;
				.img-code {
					font-size: 16px;
					text-align: center;
					border: 0;
					display: block;
					width: 100%;
					height: 100%;
				}
			}
		}
		.info {
			display: flex;
			justify-content: space-between;
			padding-bottom: 10px;
			border-bottom: 1px solid #ededed;
			.code-info {
				color: red;
				font-size: 12px;
				width: 55%;
			}
			.img-info {
				font-size: 12px;
				width: 40%;
			}
		}
		.code-submit {
			font-size: 16px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #2e2e33;
			line-height: 23px;
			margin-top: 13px;
		}
	}
}
.popup-abs {
	position: fixed;
	z-index: 10000000000;
	top: 0;
	bottom: 0;
	width: 100%;
	background: rgba(3, 3, 3, 0.5);
}
.popup-nocode {
	position: fixed;
	bottom: 0;
	z-index: 2;
	padding: 16px 29px;
	border-radius: 12px 12px 0 0;
	width: 100%;
	background: #fff;
	height: 380px;
	&-title {
		height: 24px;
		font-size: 17px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #2e2e33;
		line-height: 24px;
		text-align: center;
	}
	&-backimg {
		position: absolute;
		width: 22px;
		height: 22px;
	}
	&-content {
		margin-top: 16px;
		p {
			font-size: 13px;
			font-family: DINPro-Regular, DINPro;
			color: #414146;
			line-height: 24px;
		}
	}
}
.popup-bottom {
	position: fixed;
	bottom: 0;
	z-index: 2;
	padding: 0 29px;
	border-radius: 12px 12px 0 0;
	width: 100%;
	background: #fff;
	height: 400px;
	&-close {
		float: right;
		margin: 20px 0;
		width: 20px;
		height: 20px;
	}
	&-title {
		margin-top: 20px;
		font-size: 17px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #2e2e33;
		line-height: 24px;
	}
	&-tips {
		margin-top: 6px;
		height: 21px;
		font-size: 13px;
		font-family: DINPro-Regular, PingFangSC-Regular, PingFang SC;
		color: #9999a0;
		line-height: 21px;
	}
	.verify-code {
		display: flex;
		justify-content: space-between;
		margin-top: 12px;
	}
	.not-get-code {
		height: 21px;
		font-size: 13px;
		font-family: PingFangSC-Regular, PingFang SC;
		color: #2e2e33;
		line-height: 21px;
	}
	.right-tips {
		height: 21px;
		font-size: 13px;
		font-family: DINPro-Regular, DINPro;
		color: #919199;
		line-height: 21px;
		&-red {
			color: #ff3838;
		}
	}
}
.popup-bottom-focus {
	height: 190px;
}
.popup-bottom-ios {
	height: 210px;
}
.dialog-success {
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	background: rgba(3, 3, 3, 0.5);
	min-height: 700px;
	z-index: 99999;
	.dialog-bg {
		opacity: 0.5;
		background-color: #000;
	}
	.dialog-box {
		position: relative;
		max-width: 260px;
		width: 70%;
		margin: -110px auto auto;
		top: 50%;
		display: block;
		z-index: 10000;
		background-color: #fff;
		border-radius: 5px;
		padding: 5px 0;
		text-align: center;
		color: #666;
		.title {
			font-weight: bold;
			font-size: 18px;
			line-height: 32px;
		}
		.text {
			border-bottom: 1px solid #dcdedf;
			font-size: 12px;
			line-height: 20px;
			padding: 8px 0;
		}
		.dialog-buttons {
			font-size: 16px;
			line-height: 34px;
		}
	}
}
</style>